// extracted by mini-css-extract-plugin
export default {"blockTitle":"editableFile_blockTitle__p0Bqs","actionIcon":"editableFile_actionIcon__LjSI8"};